import { createRoot } from "react-dom/client";
import { App } from "./App";

function main() {
    const container = document.getElementById("app");
    const root = createRoot(container);
    root.render(<App />);
}

function bootstrap(main) {
    if (document.readyState === "loading") {
        const done = () => {
            document.removeEventListener("DOMContentLoaded", done);
            main();
        };
        document.addEventListener("DOMContentLoaded", done);
    } else {
        setTimeout(main);
    }
};

bootstrap(main);
